import script from "./UnitDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./UnitDetailView.vue?vue&type=script&setup=true&lang=js"

import "./UnitDetailView.vue?vue&type=style&index=0&id=34c44220&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34c44220"]])

export default __exports__